export var InputKeyCodes;
(function (InputKeyCodes) {
  InputKeyCodes["BACKSPACE"] = "Backspace";
  InputKeyCodes["LEFT_ARROW"] = "ArrowLeft";
  InputKeyCodes["UP_ARROW"] = "ArrowUp";
  InputKeyCodes["RIGHT_ARROW"] = "ArrowRight";
  InputKeyCodes["DOWN_ARROW"] = "ArrowDown";
  InputKeyCodes["ENTER"] = "Enter";
})(InputKeyCodes || (InputKeyCodes = {}));
export var invalidKeys = ['-', 'e', '+', 'E', '.', ','];
export var replaceCharAtIndex = function replaceCharAtIndex(char, str, index) {
  return str.slice(0, index) + char + str.slice(index + 1);
};
export var getDataByEvent = function getDataByEvent(e) {
  var _e$target$dataset$id, _e$target$dataset;
  return {
    index: Number(((_e$target$dataset$id = (_e$target$dataset = e.target.dataset) === null || _e$target$dataset === void 0 ? void 0 : _e$target$dataset.id) !== null && _e$target$dataset$id !== void 0 ? _e$target$dataset$id : '0').replace(/^\D+/g, '')),
    value: e.target.value
  };
};
export var isNumeric = function isNumeric(value) {
  return /^\d+$/.test(value);
};

// Для того чтоб не ругался ts на сравнение enum
export var isEqual = function isEqual(a, b) {
  return a === b;
};
export var getOnlyNumbersFromString = function getOnlyNumbersFromString(s, length) {
  return s.replace(/\D/g, '').substring(0, length);
};